// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__2JSQG bodySBold","title":"Divider_title__2D9ok"};